import { useState } from "react";
import CheckboxItem from "../../components/Form/CheckboxItem";
import Heading from "../../components/Common/Heading";
import styled from "styled-components";

const StyledCategoryFilter = styled.div`
    background-color: #7E98B0;
    color:#fff;

    .categoryFilterHeader{
        background-color:#2C3E50;
        padding:25px;
    }

    .categoryFilterBody{
        padding:15px 25px;
    }

    .categoryFilterBody .checkboxItem{
        padding:5px 0;
    }

    .categoryFilterBody input{
        margin:0 1em 0 0;
    }
`

type IzobrazevanjeListGroupFilterArgs = {
    groups: string[],
    headerText?: string | null,
    onGroupChange: (selected: string[]) => void,
}

const IzobrazevanjeListGroupFilter = ({ groups, headerText, onGroupChange }: IzobrazevanjeListGroupFilterArgs) => {
    const [selectedGroupData, setSelectedGroupData] = useState(groups);

    const onGroupSelectionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { checked, value } = event.target;
    
        setSelectedGroupData((prevSelectedGroupData) => {
            const updatedGroupData = checked
                ? [...prevSelectedGroupData, value]
                : prevSelectedGroupData.filter((item) => item !== value);
    
            onGroupChange(updatedGroupData);
            return updatedGroupData;
        });
    };

    return (
        <>
            {
                <StyledCategoryFilter>
                    {headerText &&
                        <div className="categoryFilterHeader">{headerText}</div>
                    }
                    {groups && 
                        <div className="categoryFilterBody">
                            {groups.map((group) => (
                                <CheckboxItem
                                    key={group}
                                    id={group}
                                    value={group}
                                    name={group}
                                    checked={selectedGroupData.includes(group)}
                                    onChange={onGroupSelectionChange}
                                    label={group}
                                />
                            ))}
                        </div>
                    }
                </StyledCategoryFilter>
            }
        </>
    );
}

export default IzobrazevanjeListGroupFilter;